var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 605.85 399.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#961a27;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.15,396.78S4.85,62.88,241.85,70.88,511.74,0,511.74,0,637.9,241.25,276.63,231.33a158.87,158.87,0,0,1-19.24-1.65C228.17,225.34,106.53,219.06,30.15,396.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.47,181.88s138.9,75.41,100.14,217.71H554.69s5.62-115.07-100.61-194.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.15,396.78l28.23.38s21.63-96.7,73.05-135l-65.58-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.79,156.8S577,210.58,587.43,290.73s-73.64-67-73.64-67l-42-41.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "430.88 214.19 423.85 253.88 480.64 227.88 487.85 190.88 443.73 190.88 430.88 214.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.55 232.88 0 314.64 52.84 307.87 46.55 232.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "575.85 281.88 605.85 268.88 590.85 327.24 575.85 281.88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset10);
export default __webpack_public_path__ + "static/media/Asset 10.714f273a.svg";
export { ForwardRef as ReactComponent };